import templateOnly from '@ember/component/template-only';

export interface CardSignature {
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

const CardComponent = templateOnly<CardSignature>();

export default CardComponent;
